import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAyX7p--UFToFPoiSKeY02ugns_mlvDqig",
  authDomain: "shadhin-fintech.firebaseapp.com",
  projectId: "shadhin-fintech",
  storageBucket: "shadhin-fintech.appspot.com",
  messagingSenderId: "718472664828",
  appId: "1:718472664828:web:679a69f675359ddcc26979",
  measurementId: "G-SFBV4FW0QM",
};

initializeApp(firebaseConfig);
export default getMessaging();
